export default __webpack_public_path__ + "static/media/airConditioner.a539433a.jpeg";